import moment from "moment";
import { PlotProps } from "../types/echarts";

const flowPlot = ({
  series,
  displayName,
  unit,
  ipcScore,
  droughtEvents,
  isClimateData,
}: PlotProps) => {
  // const color = series.map(
  //   (item) => (item.lineStyle.color = getAnomalyColor(item.name))
  // );
  const legenddata = series
    .filter(
      (each) =>
        !isClimateData ||
        each.name === "Drought Event" ||
        each.name === "IPC Score",
    )
    .map(({ name }) => ({ name }));

  const selectedLegend = () => {
    const selected: Record<string, boolean> = {};
    // legenddata.forEach(({ name }, index) => selected[name] = (ipcScore || droughtEvents) && index === (legenddata.length - 1) ? true : displayName?.includes(name) ?? false);
    legenddata.forEach(({ name }, index) => (selected[name] = true));
    return selected;
  };

  const yAxis = [
    {
      type: "value",
      name: unit ?? "anomaly",
      nameLocation: "end",
      alignTicks: false,
      splitLine: {
        show: true,
        // show: isClimateData,
      },
    },
  ];

  if (ipcScore || droughtEvents)
    yAxis.push({
      type: "value",
      name: "[-]",
      nameLocation: "end",
      alignTicks: true,
      splitLine: {
        show: isClimateData,
      },
    });

  const option = {
    // color,
    legend: {
      data: legenddata,
      selected: { ...selectedLegend() },
      padding: 7,
      top: 0,
      textStyle: {
        fontSize: "12px",
      },
      itemGap: 20,
    },
    xAxis: {
      type: "time",
      minInterval: 365 * 24 * 60 * 60 * 1000,
      axisTick: {
        show: true,
        interval: (_index: number, value: number) =>
          moment(value).month() === 0, // January only
      },
      splitNumber: 10,
      splitLine: {
        show: true,
        interval: (_index: number, value: number) =>
          moment(value).month() === 0,
        lineStyle: {
          color: "#E0E0E0",
          width: 1,
        },
      },
      axisLabel: {
        formatter: (value: number) => moment(value).format("YYYY"),
        hideOverlap: true,
      },
    },
    yAxis,
    grid: {
      top: isClimateData ? 36 : 56,
      left: 40,
      right: 24,
      bottom: 12,
    },
    tooltip: {
      show: true,
      trigger: "axis",
      valueFormatter: (value: string | number) =>
        typeof value != "string" ? value.toFixed(2) : value,
      axisPointer: {
        label: {
          formatter: (params: any) => {
            const timestamp = params.value;
            const formattedDate = moment(timestamp).format(
              isClimateData ? "YYYY-MM-DD" : "YYYY",
            );
            return `${formattedDate}`;
          },
        },
      },
    },
    toolbox: {
      magicType: { show: true, type: ["line", "bar"] },
      feature: {
        dataZoom: {
          yAxisIndex: "none",
        },
        restore: {},
        saveAsImage: {
          pixelRatio: 10,
          backgroundColor: "white",
        },
      },
      top: 8,
      left: "left",
      orient: "vertical",
      // transform: 'translateY(-50%)',
    },
    // dataZoom: [
    //   {
    //     type: 'slider',
    //     top: 0,
    //     height: 20,
    //   }
    // ],
  };

  return { series, option };
};

export default flowPlot;
